// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:767px){.carouselCategories .carousel__viewport{border-radius:0!important}}@media screen and (min-width:728px) and (max-width:1023px){.carouselCategories .carousel__slide{width:-moz-max-content!important;width:max-content!important}}", ""]);
// Exports
module.exports = exports;
